/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo constant
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { ICampaignInfoReducer } from './campaignInfoReducer';
import { ECampaignInfoType } from './types/campaignInfoTypes';

/*
* -------------------------------------------
*            INIT PAGE
* -------------------------------------------
*/

export const CAMPAIGN_INFO_INIT_START = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_INIT_START';
export const CAMPAIGN_INFO_INIT_SUCCESS = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_INIT_SUCCESS';
export const CAMPAIGN_INFO_INIT_FAILURE = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_INIT_FAILURE';

export const CAMPAIGN_INFO_LINK_VISITED = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_LINK_VISITED';

/*
* -------------------------------------------
*            MODAL APPLY & REMOVE
* -------------------------------------------
*/
export const CAMPAIGN_INFO_GET_ACTIVATE_TYPE = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_GET_ACTIVATE_TYPE';

export const CAMPAIGN_INFO_ACTIVATE_START = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_SEND_INQUIRY_START';
export const CAMPAIGN_INFO_ACTIVATE_SUCCESS = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_SEND_INQUIRY_SUCCESS';

export const CAMPAIGN_INFO_REMOVE = '@@b2b_portal_ui/campaignInfo/CAMPAIGN_INFO_REMOVE';

/*
* -------------------------------------------
*           Initial state
* -------------------------------------------
*/

export const campaignInfoInitialState: ICampaignInfoReducer = {
    actions: [],
    activateResult: {
        campaignInquiryId: 0,
    },
    info: {
        id: 0,
        type: ECampaignInfoType.account,
        text: {
            btnApply: '',
        },
    },
    isError: false,
    isLoading: false,
};
